<template>
  <section class="team">
    <div class="content-max-width">

      <!-- <div class="tabs">
        <ul>
          <li v-for="(group, index) in groups" :key="index" :class="isActive(group)" @click="selectGroup(group)">{{ group }}</li>
        </ul>
      </div> -->


      <div class="content">

        <div v-for="(department, deptIndex) in people" :key="deptIndex">
          <h4>{{ department.name }}</h4>
          <!-- v-if="hidePerson(person, department)" -->
          <div class="flex cards flex-center">
            <div class="card" v-for="(person, index) in department.people" :key="person.id">
              <img :src="person.image" alt="">
              <h4> {{ person.name}}</h4>
              <p>{{ person.position }}</p>
              <a href="#" class="read-more" @click.prevent="toggleModal(deptIndex, index)">Read More</a>
            </div>
          </div>
        </div>


       <!-- <div class="flex cards flex-center" v-for="(department, deptIndex) in people" :key="deptIndex"
             v-if="department.name === '' && !hasDepartment">

          <h4>{{ department.name }}</h4>

          <div class="card" v-for="(person, index) in department.people" :key="person.id">

            <img :src="person.image" :alt="person.name">
            <h4>{{ person.name }}</h4>
            <p>{{ person.position }}</p>
            <a href="#" class="read-more" @click.prevent="toggleModal(deptIndex, index)">Read More</a>

          </div>
        </div>
         -->

        <!--

          <div class="flex cards flex-between" v-for="(department, deptIndex) in people" :key="deptIndex"
               v-if="activeGroup === 'Staff' && department.people.length > 0">

              <h4>{{ department.name }}</h4>

              <div class="card" v-for="(person, index) in department.people" :key="person.id" v-if="hidePerson(person)">

                  <img :src="person.image" :alt="person.name">
                  <h4>{{ person.name }}</h4>
                  <p>{{ person.position }}</p>
                  <a href="#" class="read-more" @click.prevent="toggleModal(deptIndex, index)">Read More</a>

              </div>
          </div>
         -->
      </div>

      <portal v-if="showingModal" to="modal">
            <app-modal @close="toggleModal" class="history">
            <div class="flex flex-start">
                <img :src="activePerson.image" :alt="activePerson.name">
                <div class="description people">
                <div class="top">
                    <h4>{{ activePerson.name }}</h4>
                    <p class="job-title">{{ activePerson.position }}</p>
                    <p>{{ activePerson.content }}</p>
                </div>

                <!--<div class="bottom">
                    <h5>Contact Details</h5>
                    <a :href="'mailto:' + activePerson.email" class="email">{{ activePerson.email }}</a>
                    <a :href="'tel:' + activePerson.phone" class="tel">{{ activePerson.phone }}</a>
                </div>-->

                </div>
            </div>
            </app-modal>
        </portal>

    </div>
  </section>
</template>
<script>
export default {
  props: {
    groups: Array,
    people: Array,
    departments: Array
  },

  data () {
    return {
      activeGroup: 'Board',
      showingModal: false,
      hasDepartment: false,
      activeClass: {
        active: false
      },
      activePerson: {
          name: '',
          position: '',
          mail: '',
          phone: '',
          image: ''
      },
      members: []
    }
  },

  mounted ()  {
      //console.log(this.groups)
      console.log(this.people)
      //console.log(this.departments)
  },

  methods: {
    toggleModal (deptIndex, index) {
      this.showingModal = ! this.showingModal


      if (deptIndex !== null && index !== null) {
        this.activePerson.name = this.people[deptIndex].people[index].name
        this.activePerson.email = this.people[deptIndex].people[index].email
        this.activePerson.phone = this.people[deptIndex].people[index].phone
        this.activePerson.image = this.people[deptIndex].people[index].image
        this.activePerson.position = this.people[deptIndex].people[index].position
        this.activePerson.content = this.people[deptIndex].people[index].content
      }

    },

    isActive (currentGroup) {
      if (currentGroup === this.activeGroup) {
        return {active : true}
      } else {
        return {active : false}
      }
    },

    selectGroup(group) {
      this.activeGroup = group
      if (group === "Staff") {
          this.hasDepartment = true
      }
      else {
          this.hasDepartment = false
      }
    },

    getPeople (department) {


        //if (person['name'].people.length > 0) {
          //this.members = this.people.name.filter(department)
          //console.log(department, this.members)
          this.members = this.people.find(dept => dept.name === department).people
            //.filter(function(person) {
            //return person.name == department;
          //});

          //console.log(this.members, department)

          return true
       // }
        //return false
    }

  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/PeopleCard.vue